(function ($) {
    'use strict';

    document.addEventListener('DOMContentLoaded', function () {

        //блокировка пользователей дропменю
        $(document).on('click', '.js-icon-blocked-user', function () {
            let $target = $(this);
            let $iconWrapper = $target.closest('.js-icon-wrapper');
            let $dropMenu = $iconWrapper.find('.js-dropmenu-time-blocked');

            $dropMenu.toggle('opened');
        });

        // Открыть фильтры
        $(document).on('click', '.js-filter-button-open', function () {
            let $target = $(this);
            let $wrapper = $target.closest('.js-filter-wrapper');

            if (!$wrapper.hasClass('opened')) {
                $wrapper.addClass('opened');
            } else {
                $wrapper.removeClass('opened');
            }
        });

        //Скрыть фильтры
        $(document).on('click', '.js-filter-show-button', function () {
            $(this).closest('.js-filter-wrapper').removeClass('opened');
        });

        // Показать календарь
        $(document).on('click', function (e) {
            let $target = $(e.target);

            if (!$target.closest('.js-side-archive').length) {
                let $calendarWrap = $target.closest('.js-title-calendar-wrap');
                if ($calendarWrap.length > 0) {
                    $calendarWrap.addClass('active');
                }

                if ($calendarWrap.length === 0) {
                    $('.js-title-calendar-wrap').removeClass('active');
                }
            }
        });

        // Скрыть календарь при клике на кнопку на мобилке
        $(document).on('click', '.js-hide-calendar', function (e) {
            e.stopPropagation();
            let $calendarWrap = $(this).closest('.js-title-calendar-wrap')

            if ($calendarWrap.hasClass('active')) {
                $calendarWrap.removeClass('active');
            }
        });

        //Обработчик поля редактирования
        $(document).on('click', '.js-edit-button', function (e) {
            let $holderComment = $(e.target).closest('.js-comments-item-holder');
            let $commentArea = $holderComment.find('.js-comment-area');
            let $commentForm = $holderComment.find('.js-comment-form');
            let textArea = $commentForm.find('.js-textarea').get(0);

            // открыть/закрыть поле редактирования/текст сообщения
            $commentArea.toggle();
            $commentForm.toggle();

            //Установить высоту для поля редактирования по контенту
            $(textArea).css('height', '').css('height', textArea.scrollHeight);

            //Инициализировать кастомный скролл на поле редактирования
            if (typeof PerfectScrollbar !== 'undefined') {
                $(textArea).data('ps', new PerfectScrollbar(textArea, {
                    suppressScrollX: true,
                }));
            }

        });

        //Закрыть дроп-меню при клике вне
        $(document).on('click', function (e) {
            if ($(e.target).closest('.js-icon-wrapper').length === 0) {
                $('.js-dropmenu-time-blocked').hide('slow');
            }

        });
    });

})(jQuery);
